function getSentryEnvironment() {
  return process.env.GATSBY_SENTRY_ENV;
}

function getSentryDsn() {
  return process.env.GATSBY_SENTRY_DSN;
}

function isSentryEnabled() {
  return getSentryDsn() && process.env.GATSBY_SENTRY_ENABLED === 'true';
}

module.exports = { getSentryEnvironment, getSentryDsn, isSentryEnabled };
